<script setup>
import {computed} from 'vue'
import {useStore} from "vuex";
// форматирование суммы
import {priceFormat} from '@/use/price-format'
//----------------------------------------------------------------------
const store = useStore()

// для графика платежей
const payments = computed( () => {return store.getters['contractModule/pastPayments']})

</script>
<template>

  <div class="card card-outline card-info">
    <div class="card-body">
        <table
            class="table"
        >
          <thead>
          <tr>
            <th style="width: 30px" class="border-0">№</th>
            <th style="width: 200px" class="border-0 text-center">Дата платежа</th>
            <th style="width: 200px" class="border-0 text-center">Сумма платежа</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in payments" :key="index">
            <td>{{ index+1 }}</td>
            <td class="text-center">{{ item.Date }}</td>
            <td class="text-center">{{ priceFormat(item.Summ) }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>